<template>
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
          <md-card-content>
  
            <md-table :value="queriedData" class="paginated-table table-striped table-hover">
              <md-table-toolbar class="toolbar-margin">
                  <md-field>
                    <label for="pages">Per page</label>
                    <md-select v-model="pagination.size" name="pages">
                      <md-option v-for="item in this.perPageOptions" :key="item" :label="item" :value="item">
                        {{ item }}
                      </md-option>
                    </md-select>
                  </md-field>
    
                  <!-- 버튼 -->
                  <slot name="top-buttons"></slot>
              </md-table-toolbar>
  
              <template v-slot:md-table-row="{ item }">
                <md-table-row>
                  <md-table-cell v-for="(column, index) in columns" :key="index" :md-label="column.label"
                    :md-sort-by="column.sortBy">
                    <template v-if="column.type === 'text'">
                      <div :class="{ 'text-highlight': column.highlighted }">
                        {{ item[column.field] }}
                      </div>
                    </template>
  
                    <template v-else-if="column.type === 'button'">
                      <md-button v-for="(action, actionIndex) in column.actions" :key="actionIndex"
                        :class="`md-just-icon ${action.buttonClass} action-icon`" @click="action.handler(item)">
                        <md-icon>{{ action.icon }}</md-icon>
                      </md-button>
                    </template>
                  </md-table-cell>
                </md-table-row>
              </template>
            </md-table>
  
            <div class="footer-table md-table">
              <table>
                <tfoot>
                  <tr>
                    <th v-for="(column, index) in columns" :key="index" class="md-table-head">
                      <div class="md-table-head-container md-ripple md-disabled">
                        <div class="md-table-head-label">
                          {{ column.label }}
                        </div>
                      </div>
                    </th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </md-card-content>
  
          <div class="bottom-buttons">
            <slot name="bottom-buttons"></slot>
          </div>
  
          <md-card-actions md-alignment="space-between">
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of
                {{ pagination.total_elements }} entries
              </p>
            </div>
            <pagination class="pagination-no-border pagination-success" v-model="pagination.page"
              :perPage="pagination.size" :totalElements="pagination.total_elements" :totalPages="pagination.total_pages">
            </pagination>
          </md-card-actions>
      </div>
    </div>
  </template>
  
  <script>
    import Pagination from "@/components/Tables/Pagination.vue";
  
    export default {
      components: {
        Pagination,
      },
      props: {
        columns: {
          type: Array,
          required: true,
        },
        data: {
          type: Object,
          required: true,
          default: () => ({
            page_info: {
              page: 1,
              size: 5,
              total_elements: 20,
              total_pages: 4
            }, elements: [],
          })
        },
      },
  
      computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
          let result = this.tableData;
          if (this.searchedData.length > 0) {
            result = this.searchedData;
          }
  
          if (!result) {
            return [];
          }
  
          return result;
        },
        to() {
          let highBound = this.from + this.pagination.size;
          if (this.pagination.total_elements < highBound) {
            highBound = this.pagination.total_elements;
          }
          return highBound;
        },
        from() {
          return this.pagination.size * (this.pagination.page - 1);
        },
      },
      data() {
        return {
          currentSort: "name",
          currentSortOrder: "asc",
          pagination: this.data.page_info,
          tableData: this.data.elements,
          perPageOptions: [5, 10, 25, 50],
          searchedData: [],
        };
      },
      methods: {
      },
      watch: {
        'pagination.page': {
          handler() {
            this.$emit("updatePagination", this.pagination);
          },
        },
        'pagination.size': {
          handler() {
            this.pagination.page = 1;
            this.$emit("updatePagination", this.pagination);
          },
        },
      },
    };
  </script>
  
  <style lang="scss" scoped>
    $primary-color: #ff9800;
  
    .action-icon {
      margin: 5px;
    }
  
    .bottom-buttons {
      margin-bottom: 10px;
      margin-left: 10px;
    }
  
    .text-highlight {
      font-weight: 700;
      color: $primary-color;
    }
  
    .toolbar-margin {
      margin-bottom: 20px;
    }
  </style>
  